import { alias, AliasedConstructor } from '../../rest/decorators/alias'
import {
  Serialisable,
  SerialisationConfig,
} from '../../rest/utilities/serialisable'

export class FileBranch extends Serialisable {
  public static override serialisationConfig: SerialisationConfig =
    new SerialisationConfig(() => new FileBranch())

  @alias('id')
  id!: number
  @alias('name')
  name!: string
  @alias('children')
  children!: FileBranch[] | null

  constructor() {
    super((FileBranch as unknown as AliasedConstructor)._alias)
  }

  static create<Data>(attrs: Data) {
    return new FileBranch().update(attrs, FileBranch.serialisationConfig)
  }
}
